<iframe
  width="100%"
  height="100%"
  [src]="activeUrlFinal"
  title=""
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowfullscreen
  allowtransparency="true"
></iframe>
